var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B25029"
    },
    d: "M485.808,305.67c-82.007,0-148.487-66.481-148.487-148.487c0-6.656,0.446-13.208,1.295-19.631 c-56.157-10.662-98.621-59.998-98.621-119.257c0-2.527,0.085-5.031,0.239-7.519C111.973,18.871,10.449,125.44,10.449,255.742 c0,135.578,109.908,245.483,245.482,245.483c118.602,0,217.56-84.109,240.478-195.935 C492.908,305.537,489.373,305.67,485.808,305.67z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.732,436.658c-1.492,0-3.006-0.321-4.445-0.999l-0.475-0.226c-5.206-2.489-7.409-8.727-4.919-13.934 c2.489-5.207,8.729-7.409,13.934-4.919l0.366,0.173c5.221,2.46,7.461,8.685,5.001,13.906 C183.41,434.44,179.652,436.658,175.732,436.658z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.918,418.359c-2.14,0-4.298-0.654-6.158-2.012c-29.368-21.461-52.287-50.474-66.279-83.901 c-2.229-5.323,0.281-11.445,5.604-13.672c5.325-2.229,11.445,0.281,13.674,5.605c12.52,29.913,33.038,55.881,59.331,75.096 c4.659,3.405,5.676,9.942,2.272,14.601C151.317,416.875,148.139,418.359,144.918,418.359z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255.931,511.674c-68.361,0-132.631-26.622-180.969-74.96C26.622,388.375,0,324.104,0,255.742 c0-65.508,24.732-127.827,69.639-175.477c44.712-47.44,105.061-75.823,169.935-79.918c2.98-0.19,5.92,0.916,8.042,3.035 c2.121,2.118,3.231,5.047,3.045,8.038c-0.145,2.345-0.218,4.657-0.218,6.873c0,53.24,37.902,99.077,90.12,108.991 c5.446,1.034,9.136,6.14,8.41,11.635c-0.8,6.049-1.205,12.193-1.205,18.262c0,76.115,61.925,138.038,138.038,138.038 c3.206,0,6.526-0.119,9.868-0.354c3.256-0.22,6.44,1.08,8.592,3.538c2.154,2.459,3.032,5.781,2.377,8.983 c-11.66,56.893-42.893,108.694-87.944,145.864C373.037,490.927,315.23,511.674,255.931,511.674z M229.602,22.188 C111.684,35.335,20.898,135.811,20.898,255.742c0,129.598,105.434,235.034,235.033,235.034c106.686,0,200.19-72.705,227.212-174.679 c-86.416-1.424-156.273-72.165-156.273-158.914c0-3.819,0.14-7.663,0.416-11.501C271.347,130.773,231.311,80.571,229.602,22.188z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#772800"
    },
    cx: 168.114,
    cy: 165.595,
    r: 24.801
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#772800"
    },
    cx: 182.188,
    cy: 313.187,
    r: 24.801
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#772800"
    },
    cx: 295.194,
    cy: 256,
    r: 24.801
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#772800"
    },
    cx: 325.329,
    cy: 387.49,
    r: 35.527
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.118,200.847c-19.437,0-35.25-15.813-35.25-35.25c0-19.437,15.813-35.251,35.25-35.251 c19.437,0,35.25,15.813,35.25,35.251S187.554,200.847,168.118,200.847z M168.118,151.245c-7.913,0-14.352,6.439-14.352,14.353 c0,7.914,6.439,14.352,14.352,14.352s14.352-6.439,14.352-14.352C182.469,157.684,176.031,151.245,168.118,151.245z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.185,348.436c-19.437,0-35.25-15.814-35.25-35.251c0-19.437,15.813-35.25,35.25-35.25 c19.437,0,35.25,15.814,35.25,35.25C217.436,332.622,201.622,348.436,182.185,348.436z M182.185,298.834 c-7.913,0-14.352,6.439-14.352,14.352c0,7.914,6.439,14.353,14.352,14.353s14.352-6.439,14.352-14.353 C196.538,305.271,190.099,298.834,182.185,298.834z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295.191,291.251c-19.437,0-35.25-15.813-35.25-35.25s15.813-35.25,35.25-35.25c19.437,0,35.25,15.813,35.25,35.25 S314.627,291.251,295.191,291.251z M295.191,241.648c-7.913,0-14.352,6.439-14.352,14.352c0,7.913,6.439,14.352,14.352,14.352 c7.913,0,14.352-6.439,14.352-14.352C309.543,248.087,303.104,241.648,295.191,241.648z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#772800"
    },
    cx: 473.799,
    cy: 65.014,
    r: 27.756
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M473.796,103.215c-21.065,0-38.205-17.137-38.205-38.204c0-21.065,17.138-38.204,38.205-38.204S512,43.946,512,65.012 S494.862,103.215,473.796,103.215z M473.796,47.707c-9.543,0-17.307,7.764-17.307,17.306c0,9.542,7.764,17.306,17.307,17.306 c9.543,0,17.306-7.765,17.306-17.307S483.338,47.707,473.796,47.707z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#772800"
    },
    cx: 333.876,
    cy: 66.59,
    r: 20.898
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M333.876,97.936c-17.285,0-31.347-14.061-31.347-31.346s14.062-31.346,31.347-31.346s31.347,14.062,31.347,31.346 S351.161,97.936,333.876,97.936z M333.876,56.142c-5.762,0-10.449,4.686-10.449,10.448s4.687,10.448,10.449,10.448 c5.762,0,10.449-4.686,10.449-10.448S339.638,56.142,333.876,56.142z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#772800"
    },
    cx: 436.767,
    cy: 201.3,
    r: 25.078
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M436.767,236.823c-19.59,0-35.527-15.937-35.527-35.525s15.937-35.525,35.527-35.525c19.59,0,35.527,15.937,35.527,35.525 S456.357,236.823,436.767,236.823z M436.767,186.67c-8.067,0-14.629,6.562-14.629,14.628s6.562,14.628,14.629,14.628 s14.629-6.562,14.629-14.628S444.834,186.67,436.767,186.67z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M325.328,433.462c-25.352,0-45.977-20.624-45.977-45.974c0-25.351,20.624-45.976,45.977-45.976 c25.35,0,45.974,20.624,45.974,45.976C371.302,412.839,350.677,433.462,325.328,433.462z M325.328,362.41 c-13.828,0-25.079,11.25-25.079,25.078c0,13.827,11.25,25.076,25.079,25.076c13.827,0,25.077-11.249,25.077-25.076 C350.404,373.661,339.155,362.41,325.328,362.41z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookies);
export default __webpack_public_path__ + "static/media/cookies.1278ae10e57cfd90bdf782465bef350d.svg";
export { ForwardRef as ReactComponent };